import {
    AdvancedFilterFieldTypesEnum,
    AdvancedFilterOperatorEnum,
    AdvanceFilterParamType,
    IAdvanceFilter,
    IGeneralDataAdvancedFilter
} from '../../../shared/advanced-filters/components/advance-filter';
import {
    CheckboxFilterComponent
} from '../../../shared/advanced-filters/components/filter-implementaitons/checkbox-filter/checkbox-filter.component';
import {
    DatepickerFilterComponent
} from '../../../shared/advanced-filters/components/filter-implementaitons/datepicker-filter/datepicker-filter.component';
import {
    DroplistFilterComponent
} from '../../../shared/advanced-filters/components/filter-implementaitons/droplist-filter/droplist-filter.component';
import {
    NumberFilterComponent
} from '../../../shared/advanced-filters/components/filter-implementaitons/number-filter/number-filter.component';
import {TextFilterComponent} from '../../../shared/advanced-filters/components/filter-implementaitons/text-filter/text-filter.component';
import {PredicateFilterComponent} from '../../../shared/advanced-filters/components/predicate-filter/predicate-filter.component';
import {IFilterChooser, IFilterChooserResult} from '../../../shared/advanced-filters/filter-chooser';
import {
    DocumentGeneralDataTypeEnum,
    IMetadataItemDto,
    MetaDataTypeEnum,
    ValidationTypeEnum
} from '../../settings/documentfields/metadata-item.dto';


export class DocumentFilterChooser implements IFilterChooser<AdvanceFilterParamType> {
    choose(item: IAdvanceFilter<AdvanceFilterParamType>): IFilterChooserResult<AdvanceFilterParamType> {
        switch (item.field_type) {
            case AdvancedFilterFieldTypesEnum.document_field: {
                switch ((item.item as IMetadataItemDto)?.meta_data_type) {
                    case MetaDataTypeEnum.text:
                        if ((item.item as IMetadataItemDto)?.field_validations?.validation_type === ValidationTypeEnum.numbers) {
                            return {
                                component: NumberFilterComponent,
                                inputs: {
                                    minimalValue: (<IMetadataItemDto>item?.item)?.field_validations?.min,
                                    maximalValue: (<IMetadataItemDto>item?.item)?.field_validations?.max,
                                    step: (<IMetadataItemDto>item?.item)?.field_validations?.max,
                                    availableOperators: [AdvancedFilterOperatorEnum.gt, AdvancedFilterOperatorEnum.gte, AdvancedFilterOperatorEnum.lt, AdvancedFilterOperatorEnum.lte, AdvancedFilterOperatorEnum.eq, AdvancedFilterOperatorEnum.ne]
                                }
                            }
                        }
                        return {
                            component: TextFilterComponent,
                            inputs: {
                                availableOperators: [
                                    AdvancedFilterOperatorEnum.startsWith,
                                    AdvancedFilterOperatorEnum.contains,
                                    AdvancedFilterOperatorEnum.endsWith,
                                    AdvancedFilterOperatorEnum.eq,
                                    AdvancedFilterOperatorEnum.ne
                                ]
                            }
                        };
                    case MetaDataTypeEnum.checkbox:
                        return {
                            component: CheckboxFilterComponent
                        };
                    case MetaDataTypeEnum.droplist:
                        return {
                            component: DroplistFilterComponent,
                            inputs:{
                                items:(<IMetadataItemDto>item?.item)?.meta_data_option || [],
                                availableOperators: [AdvancedFilterOperatorEnum.ne, AdvancedFilterOperatorEnum.eq]
                            }
                        };
                    case MetaDataTypeEnum.datepicker:
                        return {
                            component: DatepickerFilterComponent
                        };
                    default:
                        break;
                }
                break;
            }

            case AdvancedFilterFieldTypesEnum.person_field:
                return {
                    component: TextFilterComponent,
                    inputs: {
                        availableOperators: [
                            AdvancedFilterOperatorEnum.startsWith,
                            AdvancedFilterOperatorEnum.contains,
                            AdvancedFilterOperatorEnum.endsWith,
                            AdvancedFilterOperatorEnum.eq,
                            AdvancedFilterOperatorEnum.ne
                        ]
                    }
                };

            case AdvancedFilterFieldTypesEnum.organization_field:
                return {
                    component: TextFilterComponent,
                    inputs: {
                        availableOperators: [
                            AdvancedFilterOperatorEnum.startsWith,
                            AdvancedFilterOperatorEnum.contains,
                            AdvancedFilterOperatorEnum.endsWith,
                            AdvancedFilterOperatorEnum.eq,
                            AdvancedFilterOperatorEnum.ne
                        ]
                    }
                };

            case AdvancedFilterFieldTypesEnum.general_field: {
                if ((item.item as IGeneralDataAdvancedFilter).general_data_type === DocumentGeneralDataTypeEnum.signing_date) {
                    return {
                        component: DatepickerFilterComponent
                    };
                }
                return {
                    component: TextFilterComponent,
                    inputs: {
                        availableOperators: [
                            AdvancedFilterOperatorEnum.startsWith,
                            AdvancedFilterOperatorEnum.contains,
                            AdvancedFilterOperatorEnum.endsWith,
                            AdvancedFilterOperatorEnum.eq,
                            AdvancedFilterOperatorEnum.ne
                        ]
                    }
                };
            }

            case AdvancedFilterFieldTypesEnum.condition:
                return {
                    component: PredicateFilterComponent
                };
        }

        return {
            component: TextFilterComponent
        };
    }
}
